<template>
	<div>
		<el-tooltip effect="dark" placement="right" popper-class="tip-class">
			<div slot="content">
				1、统计查询时间内订单商品数量为0的商品<br/>
				2、作废的订单不记录统计<br/>
				3、按商品规格（SKU）维度统计
			</div>
			<img src="~/images/icon/tooltip-icon.png" style="margin-left: 10px;cursor:pointer">
		</el-tooltip>
	</div>
</template>
<script>
export default {
	name: 'IconTip',
	data () {
		return {
		}
	},
	created () {

	},
	methods: {

	}
}
</script>
<style lang="stylus" scoped>

</style>
